import { X } from 'lucide-react';
import { Badge } from '../badge';

type FilterPillProps = {
  label: string;
  onRemove: () => void;
};

// gloss
const FilterPill = ({ label, onRemove }: FilterPillProps) => {
  return (
    <Badge data-slot="filter-pill" variant="secondary" className="font-normal">
      {label}
      <button type="button" onClick={onRemove} aria-label={`Remove ${label} filter`} data-icon="inline-end">
        <X className="size-2.5" />
      </button>
    </Badge>
  );
};

export type { FilterPillProps };
export { FilterPill };
